import { mediaList } from '@/mocks/media';
import { newsList } from '@/mocks/news';
import { specialList } from '@/mocks/specials';
import type { MediaItem, NewsItem, SpecialItem } from '@/types';

export const media: MediaItem[] = mediaList as unknown as MediaItem[];
export const news: NewsItem[] = newsList as unknown as NewsItem[];
export const specials: SpecialItem[] = specialList as unknown as SpecialItem[];

export const GENRE_OPTIONS = [
  '科幻',
  '悬疑',
  '犯罪',
  '爱情',
  '剧情',
  '古装',
  '奇幻',
  '冒险',
  '历史',
  '都市',
  '医疗',
  '惊悚',
];

export const REGION_OPTIONS = ['中国大陆', '中国香港', '美国', '日本', '英国'];

export function getMediaWithType(type: 'movie' | 'tv'): MediaItem[] {
  return media.filter((item) => item.type === type);
}

export function getMediaById(id?: string): MediaItem | undefined {
  if (!id) return undefined;
  return media.find((item) => item.id === id);
}

export function getNewsById(id?: string): NewsItem | undefined {
  if (!id) return undefined;
  return news.find((item) => item.id === id);
}

export function getSpecialById(id?: string): SpecialItem | undefined {
  if (!id) return undefined;
  return specials.find((item) => item.id === id);
}

export function getNewsByMediaId(id: string): NewsItem[] {
  return news.filter((item) => item.relatedIds.includes(id));
}

export function getRelatedMedia(item: MediaItem, count = 6): MediaItem[] {
  const scored = media
    .filter((m) => m.id !== item.id)
    .map((m) => {
      let score = 0;
      if (m.type === item.type) score += 1;
      score += m.genres.filter((g) => item.genres.includes(g)).length * 3;
      score += m.tags.filter((t) => item.tags.includes(t)).length * 2;
      score += m.cast.filter((c) => item.cast.includes(c)).length * 4;
      return { m, score };
    })
    .sort((a, b) => b.score - a.score || b.m.hot - a.m.hot);
  return scored.slice(0, count).map((s) => s.m);
}